import React, { useState } from 'react'
import { PlusCircleOutlined } from "@ant-design/icons";

import {
  Row,
  Divider,
  Form,
  Spin,
  Col,
  Descriptions,
  Typography,
  Button,
  Modal,
  Collapse
} from "antd";
import cnt from "../../../../services/definedConstant"
import { BOM } from "../../../../services/definedMethod";
import { apiConfig, labelConfig } from "../../group.config";
import styles from '../../../../assets/styles/styles';
import TextArea from 'antd/es/input/TextArea';

const { Text, Title } = Typography
const { Panel } = Collapse;

const Notes = (props) => {
  const { state, session, notesList, getNotesList } = props;
  const [useForm] = Form.useForm();

  return (
    <>
      <Row >
        <NewNote useForm={useForm} session={session} state={state} notesList={notesList} refreshNotesList={getNotesList} />
      </Row>
      <Row >

        {notesList?.length > 0 && (
          <>
            <Divider orientation="left" orientationMargin="0">
              <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                {notesList.length > 1
                  ? labelConfig.notes
                  : labelConfig.note}
              </Title>
            </Divider>
            {notesList?.map((note, index) => {
              return (
                <Col span={12} style={{ padding: "0px 8px" }} key={index}>
                  <Collapse
                    style={{
                      boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
                      marginBottom: 25,
                    }}
                    key={index}
                  >
                    <Panel
                      header={
                        <Title level={5} style={{ margin: 0 }}>
                          {note.note}
                        </Title>
                      }
                      key={index}
                    >
                      <div
                        style={{
                          border: "2px solid #F5F5F5",
                          borderRadius: 15,
                          borderBottomLeftRadius: 0,
                          borderBottomRightRadius: 0,
                          borderBottomColor: "#E2E2E2",
                        }}
                      >
                        <Row>
                          <Col
                            span={12}
                            style={{
                              backgroundColor: "#F5F5F5",
                              padding: 10,
                              borderRadius: 15,
                              borderTopRightRadius: 0,
                              borderBottomRightRadius: 0,
                              borderBottomLeftRadius: 0,
                            }}
                          >
                            <Text strong>{labelConfig.createdBy}</Text>
                          </Col>
                          <Col
                            span={12}
                            style={{
                              padding: 10,
                            }}
                          >
                            <Text style={{ color: "#b8b8b8" }}>
                              {note?.createdBy}
                            </Text>
                          </Col>
                        </Row>
                      </div>
                      <div
                        style={{
                          border: "2px solid #F5F5F5",
                          borderRadius: 0,
                          borderBottomColor: "#E2E2E2",
                        }}
                      >
                        <Row>
                          <Col
                            span={12}
                            style={{
                              backgroundColor: "#F5F5F5",
                              padding: 10,
                              borderRadius: 0,
                            }}
                          >
                            <Text strong>{labelConfig.createdOn}</Text>
                          </Col>
                          <Col
                            span={12}
                            style={{
                              padding: 10,
                            }}
                          >
                            <Text style={{ color: "#b8b8b8" }}>
                              {note?.createdOn ? BOM.DateTime(note?.createdOn, "only-date") : "-"}
                            </Text>
                          </Col>
                        </Row>
                      </div>
                      <div
                        style={{
                          border: "2px solid #F5F5F5",
                          borderRadius: 0,
                          borderBottomColor: "#E2E2E2",
                        }}
                      >
                        <Row>
                          <Col
                            span={12}
                            style={{
                              backgroundColor: "#F5F5F5",
                              padding: 10,
                              borderRadius: 0,
                            }}
                          >
                            <Text strong>{labelConfig.note}</Text>
                          </Col>
                          <Col
                            span={12}
                            style={{
                              padding: 10,
                            }}
                          >
                            <Text style={{ color: "#b8b8b8" }}>
                              {note?.note}
                            </Text>
                          </Col>
                        </Row>
                      </div>
                      <div
                        style={{
                          border: "2px solid #F5F5F5",
                          borderRadius: 15,
                          borderTopLeftRadius: 0,
                          borderTopRightRadius: 0,
                        }}
                      >
                        <Row>
                          <Col
                            span={12}
                            style={{
                              backgroundColor: "#F5F5F5",
                              padding: 10,
                              borderRadius: 15,
                              borderTopRightRadius: 0,
                              borderBottomRightRadius: 0,
                              borderTopLeftRadius: 0,
                            }}
                          >
                            <Text strong>{labelConfig.resourceId}</Text>
                          </Col>
                          <Col
                            span={12}
                            style={{
                              padding: 10,
                            }}
                          >
                            <Text style={{ color: "#b8b8b8" }}>
                              {note?.resourceId}
                            </Text>
                          </Col>
                        </Row>
                      </div>
                    </Panel>
                  </Collapse>
                </Col>
              )
            })}

          </>
        )}


      </Row>

    </>
  )
}

export default Notes


const NewNote = (props) => {

  const { useForm, session, state, notesList, refreshNotesList } = props
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };


  const onSubmit = (formValues) => {

    const url = `${apiConfig.Groups}/${state.id}/notes`;

    const body = {
      ...formValues,
      method: "POST",
      session,
    };

    setIsLoading(true);

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, labelConfig.newNoteMsg);
        // close modal
        setIsModalOpen(false);
        refreshNotesList()
        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  return (
    <>
      {BOM.HasPermission("CREATE_GROUPNOTE") &&
        <Button type="primary" shape="round" className="of-primaryBtnColor" onClick={showModal}>
          <PlusCircleOutlined />
          &nbsp;{labelConfig.add}
        </Button>}
      <Modal
        title="New Note"
        open={isModalOpen}
        okText="Save"
        cancelText="Cancel"
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        centered
        onCancel={handleCancel}
        width={800}
        modalRender={(dom) => (
          <Form
            layout="vertical"
            form={useForm}
            onFinish={onSubmit}
          >
            {dom}
          </Form>
        )}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Saving..." size="large">

          <Divider />

          <Row>
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                name={"note"}
              >
                <TextArea style={{ width: "45vh", height: "15vh" }} placeholder='Please enter a note' />
              </Form.Item>
            </Col>
          </Row>
        </Spin>
      </Modal>
    </>
  );
};
